<template>
  <div class="py-4 container-fluid">
    <div class="d-sm-flex jmy-auto mt-4 ms-auto mt-lg-0">
        <div class="my-auto ms-auto">
          <router-link :to="{ name: 'New brand' }" class="mt-2 mb-0 btn bg-gradient-success ms-lg-3 me-lg-0 me-auto mt-lg-0 "> <span>Nuevo</span> </router-link>
        </div>
    </div> 
    <div class="row">
      <div class="col-12">
        <div class="card mt-4">
            <div class="table-responsive p-4">
              <full-table v-if="!!clientsData" :items="clientsData.items" :pagination="pagination"
                :headers="headers" @changed-page="paginationPageChange" @row-change="paginationRowChange"
                @header-change="onHeaderChange" @search-change="onSearchChange" @reload-clicked="getClients">
                <template #row="client">
                  <td class="font-weight-bold">
                    <a class="cursor-pointer text-xs picko-link" title="Editar Cliente"
                      @click="goToEditar(client)">
                    {{ client.customer_sga }}
                  </a>
                  </td>
                  <td class="font-weight-bold">
                    <span class="my-2 text-xs columns">{{client.name}}</span>
                  </td>
                  <td class="font-weight-bold">
                    <span class="my-2 text-xs columns">{{client.center}}</span>
                  </td>
                  <td class="font-weight-bold">
                    <span class="my-2 text-xs columns">{{client.situation}}</span>
                  </td>
                  <td class="font-weight-bold">
                    <span class="my-2 text-xs columns">{{client.contact.email}}</span>
                  </td> <td class="font-weight-bold">
                    <span class="my-2 text-xs columns">{{client.contact.phone}}</span>
                  </td>
                  <td class="text-sm" >
                    <a class="mx-3" 
                        title="Editar Cliente"
                        style="cursor:pointer"
                        @click="goToEditar(client)">
                        <i class="fas fa-user-edit text-secondary"></i>
                    </a>  
                  </td>
                </template>
              </full-table>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FullTable } from "@/hotaka/components";
export default {
  name: "ClientList",
  components: {
    FullTable,
  },
  data()  {
    return{
      pagination: {
        total: 0,
        rows: 10,
        currentPage: 1,
        pages: {
          total: 10,
          current: 1
        },
        entries: [5, 10, 15, 20, 50]
      },
      headers:[
        {title:'Código',sort:{sorteable:true,order:""}, column: "customer_sga"},
        {title:'Nombre',sort:{sorteable:false,order:""}, column: "name"},
        {title:'Center',sort:{sorteable:false,order:""}, column: "center"},
        {title:'Situación',sort:{sorteable:false,order:""}, column: "situation"},
        {title:'Email',sort:{sorteable:false,order:""}, column: "contact.email"},
        {title:'Teléfono',sort:{sorteable:false,order:""}, column: "contact.phone"},
        {title:'Acciones',sort:{sorteable:false,order:""}},

      ],
      filters:{
        search: '',
        sort:{
          sort:'customer_sga',
          order:'ascending'
        }
      },
    }
  },
  computed: {
    clientsData() {
      return this.$store.state.customer.list.data;
    },
  },
  watch: {
    clientsData() {
      if(this.clientsData){
        this.pagination.total= this.clientsData.total;
      }
    },

  },
  mounted() {
    this.getClients();
  },
  methods: {
    getClients() {
      this.$store.commit("customer/load",{pagination:this.pagination,filters: this.filters});
    },
    goToEditar(product){
      this.$router.push({ path: "/administration/EditBrand/" + product._id});
    },
    onSearchChange(value){
      this.pagination.currentPage = 1;
      this.filters.search=value;
      this.getClients(); 
    },
    paginationPageChange(page) {
      this.pagination.currentPage = page;
      this.getClients(); 
    },
    paginationRowChange(rows) {
      this.pagination.rows = rows;
      this.getClients(); 
    },
    onHeaderChange(val){
      this.filters.sort={
        sort: val.column,
        order: val.order=='asc'? "ascending": "descending"
      }
      this.getClients(); 
    },
    
  }
};
</script>
<style scoped>
.columns {
  max-width: 150px;
}
.image{
  height: 2.2rem !important;
  border-radius: 9%;
}

.overflow-column {
  overflow: hidden;
  text-overflow: ellipsis;
}

.pointer {
  cursor: pointer;
}
</style>
